// Search reliability + English normalization
(function(){
  const isSearchPage = location.pathname.includes('/search');
  const isCatalogPage = isSearchPage || location.pathname.startsWith('/collections/');
  if(!isCatalogPage) return;

  const params = new URLSearchParams(location.search);
  const q = params.get('q') || '';

  const keepQueryOnSort = () => {
    document.querySelectorAll('form[id*="Facet"]').forEach(form => {
      if(q && !form.querySelector('input[name="q"]')) {
        const i=document.createElement('input'); i.type='hidden'; i.name='q'; i.value=q; form.appendChild(i);
      }
      if(!form.querySelector('input[name="type"]')) {
        const t=document.createElement('input'); t.type='hidden'; t.name='type'; t.value='product'; form.appendChild(t);
      }
      if(!form.querySelector('input[name="options[prefix]"]')) {
        const p=document.createElement('input'); p.type='hidden'; p.name='options[prefix]'; p.value='last'; form.appendChild(p);
      }
    });

    document.querySelectorAll('a[href*="sort_by="]').forEach(a=>{
      const u=new URL(a.href, location.origin);
      if(q && !u.searchParams.get('q')) u.searchParams.set('q', q);
      if(!u.searchParams.get('type')) u.searchParams.set('type', 'product');
      if(!u.searchParams.get('options[prefix]')) u.searchParams.set('options[prefix]', 'last');
      a.href=u.pathname+'?'+u.searchParams.toString();
    });
  };

  const normalizeSearchEnglish = () => {
    const map = {
      '筛选': 'Filter',
      '筛选条件': 'Filter',
      '供货情况': 'Availability',
      '价格': 'Price',
      '排序': 'Sort by',
      '相关性': 'Relevance',
      '价格，从低到高': 'Price, low to high',
      '价格，从高到低': 'Price, high to low',
      '最新发布': 'Newest',
      '最畅销': 'Best selling',
      '精选': 'Featured',
      '清除': 'Clear',
      '清除全部': 'Clear all'
    };
    document.querySelectorAll('h1,h2,h3,span,button,label,option,a').forEach(el=>{
      const txt=(el.textContent||'').trim();
      if(map[txt]) el.textContent = map[txt];
    });
  };

  if(isSearchPage) keepQueryOnSort();
  normalizeSearchEnglish();
  const mo=new MutationObserver(()=>{
    if(isSearchPage) keepQueryOnSort();
    normalizeSearchEnglish();
  });
  mo.observe(document.body,{childList:true,subtree:true});
})();

// Preserve established legacy internal routes without background timers.
(function () {
  function normalizeLegacyLinks() {
    document.querySelectorAll('a[href="/pages/contact"],a[href="/contact-us"],a[href="/pages/contact-us/"]').forEach(function (link) { link.setAttribute('href', '/pages/contact-us'); });
    document.querySelectorAll('a[href="/about-us"],a[href="/pages/about-us/"]').forEach(function (link) { link.setAttribute('href', '/pages/about-us'); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', normalizeLegacyLinks);
  else normalizeLegacyLinks();
  document.addEventListener('shopify:section:load', normalizeLegacyLinks);
})();
